<app-navbar-style-two></app-navbar-style-two>

<!-- <app-posnavbar></app-posnavbar> -->
<!-- <div class="banner-area-two client-slider owl-carousel owl-theme">
    <div class="client-item">
        <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeicaldevicesoftware - medeilcloud pos.png" alt="medeical device software - medeilcloud pos">
        <div class="overlay-buttons row">
            <div class="col-lg-6">
                <button type="button" class="default-btn1">14 Days Free Trial</button>
            </div>
            <div class="col-lg-6">
                <button type="button" class="default-btn1" (click)="appointment('Medical Device Vertical')">Demo Request</button>
            </div>
        </div>
    </div>
</div> -->
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-medicaldevice">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>Optimize Your Medical Device Store with Medeil – Advanced Management Software</h1>
                      <h2 i18n>Track Inventory, Manage Sales, and Ensure Compliance with Ease</h2>
                          <button i18n type="button" class="default-btn" (click)="appointment('Medical Device vertical')">Get Started Today</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">


  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & Privacy Policy
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

           </div>


         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                </div>

              <div  align="center" *ngIf="showElementsave">
                <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
              </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div><!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->


<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h1>Medical Device Store Software & Simplify Medical Equipment Retail and Distribution</h1>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
            <p i18n>
              Managing a medical device store or distribution business comes with its own set of challenges. From tracking high-value inventory and ensuring compliance to managing warranties and customer relationships, the workload can be overwhelming. That’s where Medeil’s Medical Device Store Software comes in – a powerful, all-in-one solution designed to streamline your operations and help your business grow.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
            <div class="service-item third-service">
              <div class="icon"></div>
              <h4 i18n>Save Time and Reduce Errors</h4>
            <p i18n style="line-height: 1.4;">
              Automate repetitive tasks like inventory tracking, billing, and compliance management, so you can focus on growing your business.
            </p>
              <div class="text-button">
                <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="service-item fourth-service">
              <div class="icon"></div>
              <h4 i18n>Improve Customer Experience</h4>
              <p i18n style="line-height: 1.4;">
                Provide faster, more personalized service with features like CRM and warranty tracking.
              </p>
              <div class="text-button">
                <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h4 i18n>Optimize Inventory</h4>
           <p i18n style="line-height: 1.9;">
            Avoid overstocking or running out of critical devices with real-time inventory tracking and alerts.
           </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h4 i18n>Boost Profitability</h4>
          <p i18n style="line-height: 1.9;">
            Use sales insights to identify trends, plan promotions, and increase revenue.
          </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- ---------------------------- -->

<!-- about  -->
<div id="about" class="about-us section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 align-self-center">
          <div class="section-heading">
            <h4 i18n>Who we are?</h4>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
         <p i18n>
           In the medical device software space, we are a leading provider of innovative software solutions tailored to the unique needs of medical device manufacturers, distributors, and healthcare providers. Our mission is to empower organizations in the medical device industry with cutting-edge software that streamlines operations, ensures regulatory compliance, and drives business growth.
         </p>
          </div>
          <div class="row">
              <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeil">
                    <h5 i18n><a >Standalone Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeilcloudpos">
                    <h5 i18n><a >SaaS Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeilcloudhq">
                    <h5 i18n><a >Chain Store Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/allotmed">
                    <h5 i18n><a >Distribution Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-12 text-center">
                  <div class="box-item" routerLink="/hosbay-healthcare">
                    <h5 i18n><a>Hospital Inventory Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
            <div class="col-lg-12">
           <p i18n>
           We are a trusted partner in the medical device ERP space, committed to providing innovative, comprehensive, and compliant software solutions that empower organizations to thrive in an ever-evolving healthcare landscape.
           </p>
              <div>
                <!-- <button class="gradient-button"> Start Free Trial</button> -->
               </div>
              <!-- <span>*No Credit Card Required</span> -->
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="right-image">
            <img src="https://medeilpos.blob.core.windows.net/websiteimage/medicalposbilling- medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ---- -->
<!-- ---------------------------- -->
<section class="medical-benefits-section">
  <div class="medical-container">
      <h2 i18n class="medical-title">Who Can Benefit from Medeil’s Medical Device Store Software?</h2>
      <p i18n class="medical-description">
          Our software helps medical device businesses streamline operations, manage inventory, and enhance efficiency.
      </p>

      <div class="medical-cards">
          <div class="medical-card">
            <div class="medical-icon"><i class="fas fa-store"></i></div>
              <h3 i18n>Independent Retailers</h3>
              <p i18n>Upgrade your medical device store with modern tools for inventory and sales tracking.</p>
          </div>

          <div class="medical-card">
              <div class="medical-icon"><i class="fas fa-truck-medical"></i></div>
              <h3 i18n>Medical Equipment Distributors</h3>
              <p i18n>Manage bulk orders, multiple clients, and seamless deliveries with ease.</p>
          </div>

          <div class="medical-card">
              <div class="medical-icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Hospital Suppliers</h3>
              <p i18n>Track medical equipment inventory and ensure timely hospital deliveries.</p>
          </div>
      </div>
  </div>
</section>
<div class="container mt-4">
    <div class="section-title gradient-text mt-2 mb-2" >

        <h1 i18n>Frequently Asked Questions</h1>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How is patient data protection and the integration of electronic health records (EHR) handled by your software?</h4>
                <p i18n><strong>A:</strong> This inquiry focuses on the software's security and privacy safeguards for patient data as well as its compatibility with EHR systems. In order to guarantee patient care continuity, responses should place a strong emphasis on encryption techniques, safe data transmission protocols, HIPAA compliance, and capabilities for easy connection with EHR platforms.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: What functionalities does your software provide for managing the life cycle of medical devices and filing regulatory reports? </h4>
                <p i18n><strong>A:</strong> This inquiry concerns the features of the software that are used to manage the whole medical device lifecycle, from creation and design to production, delivery, and post-market monitoring. In order to expedite time-to-market and simplify compliance procedures, responses should emphasize elements including design controls, risk management, change management, and regulatory submissions management.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Is it possible for your software to provide the remote maintenance and monitoring of medical devices used in telehealth and remote patient care?</h4>
                <p i18n><strong>A:</strong> The software's ability to provide remote medical device monitoring, diagnosis, and maintenance for telehealth and remote patient care applications is the main focus of this question. In order to facilitate virtual consultations and proactive equipment management, responses should emphasize features like remote access, real-time data streaming, predictive maintenance algorithms, and secure communication protocols.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How is data interchange and interoperability with other medical devices and healthcare IT systems ensured by your software?</h4>
                <p i18n><strong>A:</strong> The software's compatibility with medical equipment, other healthcare IT systems, and interoperability standards like HL7 and DICOM is the subject of this inquiry. In order to provide smooth data interchange and interoperability within the healthcare ecosystem, responses should outline integration capabilities, support for standardized data formats, APIs (Application Programming Interfaces), and interoperability certifications.</p>
            </div>
        </div>
    </div>


</div>
<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>
<app-footer-style-two></app-footer-style-two>
